/**
 *
 * @Info
 * As a rule of thumb we name the exported mutation
 * in CamelCaseCaps and the actual mutation value in camelCase.
 */

// GLOBAL
export const ResetStore = 'resetStore';

// AUTH STORE MUTATIONS
export const ChangeSignUpPassword = 'changeSignUpPassword';
export const ChangeConfirmSignUpPassword = 'changeSignUpPassword';
export const ChangePasswordRules = 'changePasswordRules';
export const ChangeEmail = 'changeForgotPasswordEmail';
export const SetUserData = 'setUserData';
export const SetActiveOrganization = 'setActiveOrganization';
export const SetOrgEnsuredState = 'setOrgEnsuredState';
export const SetLastOrganizationId = 'setLastOrganizationId';
export const SetPlanInfo = 'setPlanInfo';
export const SetSubscriptions = 'setSubscriptions';

// NOTIFICATIONS
export const AddToastNotification = 'addToastNotification';
export const RemoveToastNotification = 'removeToastNotification';
export const ShowToast = 'showToast';
export const AddNotification = 'addNotification';
export const RemoveNotificationById = 'removeNotificationById';
export const RemoveAllNotifications = 'removeAllNotifications';
export const RemoveAllToasts = 'removeAllToasts';
export const RemoveToastById = 'removeToastById';
export const ReadNotificationsById = 'readNotificationsById';
export const ReadAllNotifications = 'readAllNotifications';
export const SetPlatformNotifications = 'setPlatformNotifications';
// CONVERSATIONS
export const AddMessage = 'addMessage';
export const SetCurrentConversation = 'setCurrentConversation';
export const SetInitialConversation = 'setInitialConversation;';
export const SetIsMessageLoading = 'setIsMessageLoading';
export const AddChunk = 'addChunk';
export const AddChunkSSE = 'addChunkSSE';
export const UpdateImageGenImage = 'updateImageGenImage';
export const UpdateMessageId = 'updateMessageId';
export const UpdateMessageSentiment = 'UpdateMessageSentiment';
export const SetAllUserConversations = 'setAllUserConversations';

export const SetQueryValue = 'setQueryValue';
export const PopMessage = 'popMessage';
export const RemoveMessages = 'removeMessages';

// REFERENCE DIALOG
export const SetSelectedReference = 'setSelectedReference';

// MODALS
export const SetShowTranslationModal = 'setShowTranslationModal';
export const SetShowPreviewDocument = 'setShowPreviewDocument';
export const SetShowPreviewAuthorDocument = 'setShowPreviewAuthorDocument';
export const SetShowDocumentPopup = 'setShowDocumentPopup';
export const SetShowFavoritesPopup = 'setShowFavoritesPopup';
export const SetCurrentDocumentsDialog = 'setCurrentDocumentsDialog';
export const SetCreateCollectionPopup = 'setCreateCollectionPopup';

// LANGUAGE
export const SetCurrentLanguageCode = 'setCurrentLanguageCode';

// DOCUMENT
export const SetAllTemplates = 'setAllTemplates';
export const SetCurrentTemplate = 'setCurrentTemplate';
export const SetAvailableLayouts = 'setAvailableLayouts';
export const SetCurrentLayout = 'setCurrentLayout';
export const SetEditorContent = 'setEditorContent';
export const SaveEditorContentState = 'saveEditorContentState';
export const Undo = 'undo';
export const Redo = 'redo';
export const InitializeUndoRedoStack = 'initializeUndoRedoStack';
export const LoadContentFromSessionCache = 'loadContentFromSessionCache';
export const SetLayoutsListOpened = 'setLayoutsListOpened';
export const SetReferencesListOpened = 'setReferencesListOpened';

export const SetAuthoredDocuments = 'setAuthoredDocuments';
export const SetSelectedAuthoredDocument = 'setSelectedAuthoredDocument';
export const DeleteAuthoredDocumentById = 'deleteAuthoredDocumentById';
export const AddDownloadInProgress = 'addDownloadInProgress';
export const RemoveDownloadInProgress = 'removeDownloadInProgress';
export const SetInTranslationProcess = 'setInTranslationProcess';

// USER IMAGES MUTATIONS
export const SetBrandStyles = 'setBrandStyles';
export const SetRemixImage = 'setRemixImage';
